<template>
<svg :width="width" :height="height" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="45" cy="45" r="45" fill="#FFDE59"/>
<path d="M61.6654 29.582H28.332C27.6487 29.582 27.082 29.0154 27.082 28.332C27.082 27.6487 27.6487 27.082 28.332 27.082H61.6654C62.3487 27.082 62.9154 27.6487 62.9154 28.332C62.9154 29.0154 62.3487 29.582 61.6654 29.582Z" fill="#36373F"/>
<path d="M52.7818 62.232C52.5651 62.6654 52.1151 62.9154 51.6651 62.9154C51.4818 62.9154 51.2818 62.8654 51.1151 62.782L44.9985 59.732L38.8818 62.782C38.7151 62.8654 38.5151 62.9154 38.3318 62.9154C37.8818 62.9154 37.4318 62.6654 37.2151 62.232C36.8985 61.5987 37.1485 60.8487 37.7818 60.5487L43.7485 57.5654V53.332H46.2485V57.5654L52.2151 60.5487C52.8485 60.8487 53.0985 61.5987 52.7818 62.232Z" fill="#36373F"/>
<path d="M30 28.332V48.4987C30 51.6654 31.6667 53.332 34.8333 53.332H55.1667C58.3333 53.332 60 51.6654 60 48.4987V28.332H30ZM53.3 39.2987L48.05 43.682C47.5667 44.082 46.95 44.2487 46.3667 44.1487C45.7667 44.0487 45.25 43.682 44.9333 43.1487L43.1833 40.232L38.3 44.2987C38.0667 44.4987 37.7833 44.582 37.5 44.582C37.15 44.582 36.7833 44.432 36.5333 44.132C36.0833 43.5987 36.1667 42.8154 36.7 42.3654L41.95 37.982C42.4333 37.582 43.05 37.4154 43.6333 37.5154C44.2333 37.6154 44.75 37.982 45.0667 38.5154L46.8167 41.432L51.7 37.3654C52.2333 36.9154 53.0167 36.9987 53.4667 37.532C53.9 38.0654 53.8333 38.8487 53.3 39.2987Z" fill="#36373F"/>
</svg>
</template>
<script>
export default {
  name: "PublicIcon",
  props: {
    width: {
      type: Number,
      default: 90,
    },
    height: {
      type: Number,
      default: 90,
    }
  },
};
</script>